import { useEffect, useRef, useState } from 'react';
import Footer from '../footer';
import NavBar from '../nav';
import Search from '../search';
import './index.scss';

const ContactUsPage = () => {
  const [term, setTerm] = useState<string>('');
  const [inputValue, setInputValue] = useState<string>('')
  const debounce = useRef<NodeJS.Timeout>()
  // const [question, setQuestion] = useState<string>('')

  useEffect(() => {
    const searchText = sessionStorage.getItem('searchText')
    if (searchText) {
      setInputValue(searchText)
    }
  }, [])

  useEffect(() => {
    sessionStorage.setItem('searchText', term)
  }, [term])

  useEffect(() => {
    clearTimeout(debounce.current)
    debounce.current = setTimeout(() => {
      setTerm(inputValue)
    }, 500)
  }, [inputValue])

  // const onSearch = (e: ChangeEvent<HTMLInputElement>) => {
  //   setInputValue(e.target.value)

  // }

  // const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
  //   const value = e.target.value
  //   if (value.length > 100) {
  //     return
  //   }
  //   setQuestion(e.target.value)
  // }

  return <div>
    <NavBar />
    <section>
      <div className='contact-us'>
      <div className="container content-container main-content-container contact-us-container">
          <div className="block-heading main-header"><h1 className="text-info">Contact Us</h1></div>			
          <div className="general-form">
            <div className="form-group">
              <label className="form-label">Name:</label>									
              <input type="text" id="form_name" className="form-control form-field" />															
            </div>
            <div className="form-group">
              <label className="form-label">Company:</label>									
              <input type="text" id="form_company" className="form-control form-field" />
            </div>				
            <div className="form-group">
              <label className="form-label">Phone:</label>									
              <input type="text" id="form_phone" className="form-control form-field" placeholder="xxx-xxx-xxxx" />																	
            </div>													
            <div className="form-group">
              <label className="form-label">Email:</label>									
              <input type="text" id="form_email" className="form-control form-field" />																
            </div>					
            <div className="form-group">
              <label className="form-label">Subject</label>
              <input type="text" id="form_subject" className="form-control form-field" />
            </div>	
            <div className="form-group">
              <select id="form_part" name="form_part" className="select-container form-control">
                <option value="-1">- Part -</option>
                <option value="91">91</option>
                <option value="121">121</option>
                <option value="125">125</option>
                <option value="135">135</option>
              </select>
            </div>	
            <div className="form-group">
              <select id="form_manual_type" name="form_manual_type" className="select-container form-control">
                <option value="-1">- Manual Type -</option>
                    <option value="All Airframe">All Airframe</option>
                  
                <optgroup label="Helicopters">
                    <option value="Agusta AB139">Agusta AB139</option>
                    <option value="Bell 407">Bell 407</option>
                    <option value="BHT 429">BHT 429</option>
                    <option value="R-44">R-44</option>
                    <option value="SK-76 (Series)">SK-76 (Series)</option>
                  
                </optgroup>
                  
                <optgroup label="Aircrafts">
                    <option value="Boeing B-737">Boeing B-737</option>
                    <option value="Boeing B-757">Boeing B-757</option>
                    <option value="Bombadier CL-350">Bombadier CL-350</option>
                    <option value="Bombardier BD-700">Bombardier BD-700</option>
                    <option value="Bombardier CL-300">Bombardier CL-300</option>
                    <option value="Bombardier CL-600 Series">Bombardier CL-600 Series</option>
                    <option value="Cessna CE-208">Cessna CE-208</option>
                    <option value="Cessna CE-441">Cessna CE-441</option>
                    <option value="Cessna CE-525">Cessna CE-525</option>
                    <option value="Cessna CE-560">Cessna CE-560</option>
                    <option value="Cessna CE-560XL">Cessna CE-560XL</option>
                    <option value="Cessna CE-650">Cessna CE-650</option>
                    <option value="Cessna CE-680">Cessna CE-680</option>
                    <option value="Cessna CE-750">Cessna CE-750</option>
                    <option value="Dassault DA-2000">Dassault DA-2000</option>
                    <option value="Dassault DA-50">Dassault DA-50</option>
                    <option value="Dassault DA-7X">Dassault DA-7X</option>
                    <option value="Dassault DA-900">Dassault DA-900</option>
                    <option value="EMB-145">EMB-145</option>
                    <option value="EMB-505">EMB-505</option>
                    <option value="EMB-545">EMB-545</option>
                    <option value="EMB-550">EMB-550</option>
                    <option value="Gulfstream G-III">Gulfstream G-III</option>
                    <option value="Gulfstream G-IV">Gulfstream G-IV</option>
                    <option value="Gulfstream G-IV-X">Gulfstream G-IV-X</option>
                    <option value="Gulfstream G-V">Gulfstream G-V</option>
                    <option value="Gulfstream G-V-SP (G550)">Gulfstream G-V-SP (G550)</option>
                    <option value="Gulfstream G100">Gulfstream G100</option>
                    <option value="Gulfstream G200">Gulfstream G200</option>
                    <option value="Gulfstream G280">Gulfstream G280</option>
                    <option value="Gulfstream G500">Gulfstream G500</option>
                    <option value="Gulfstream G600">Gulfstream G600</option>
                    <option value="Gulfstream G650">Gulfstream G650</option>
                    <option value="Hawker Beechcraft BE-200">Hawker Beechcraft BE-200</option>
                    <option value="Hawker Beechcraft BE-300">Hawker Beechcraft BE-300</option>
                    <option value="Hawker Beechcraft BE-350">Hawker Beechcraft BE-350</option>
                    <option value="Hawker Beechcraft BE-400A">Hawker Beechcraft BE-400A</option>
                    <option value="Hawker Beechcraft BE-90">Hawker Beechcraft BE-90</option>
                    <option value="Hawker Beechcraft HS-700">Hawker Beechcraft HS-700</option>
                    <option value="Hawker Beechcraft HS-800">Hawker Beechcraft HS-800</option>
                    <option value="Hawker Beechcraft HS-900">Hawker Beechcraft HS-900</option>
                    <option value="Hawker Beechcraft MU-300">Hawker Beechcraft MU-300</option>
                    <option value="Hawker Beechcraft RA-390">Hawker Beechcraft RA-390</option>
                    <option value="Learjet LR-35">Learjet LR-35</option>
                    <option value="Learjet LR-45">Learjet LR-45</option>
                    <option value="Learjet LR-55">Learjet LR-55</option>
                    <option value="Learjet LR-60">Learjet LR-60</option>
                    <option value="Learjet LR-70">Learjet LR-70</option>
                    <option value="MD-87">MD-87</option>
                    <option value="Pilatus PC-12">Pilatus PC-12</option>
                    <option value="Single-Engine Aircraft (General)">Single-Engine Aircraft (General)</option>
              </optgroup></select>
            </div>						
            <div className="form-group">
              <label>Message</label>
              <textarea id="form_message_body" className="form-control"></textarea>
            </div>
            {/* <div className="form-group">
              <div className="cap-container clearfix">
                <img className="cap-img" src="/__includes/contact/captcha.php" alt="Captcha Validator" data-type="contact-us"/>
                <img className="cap-refresh" src="/assets/img/refresh.png" alt="Refresh Captcha" data-type="contact-us" />
                <i className="fas fa-redo refresh-captcha"></i>
                <input type="text" id="captcha" name="captcha_challenge" className="form-control form-field cap-input" data-type="contact-us" maxLength={6} placeholder="Enter Code" />							
              </div>
            </div> */}
            <div className="form-group">
              <button id="form_btn_send" className="btn btn-primary btn-block btn_action first-button">Send</button>
            </div>						
          </div>
        </div>
      </div>
    </section>
    {term && <Search term={term} />}
    <Footer />
  </div>
}

export default ContactUsPage